export const objectToString = object => {
  let result = "";
  if (object) {
    Object.keys(object).forEach(key => {
      if (result.length) result += ", ";
      result += `${key}: ${object[key]}`;
    });
  }
  return result;
};
